import { useMemo } from 'react';
import { ProcSearchResponse } from '@/shared/api';

export enum SortOption {
  ALPHABETICAL = 'alphabetical',
  NEWEST = 'newest',
}

export const SORT_OPTIONS: { label: string; value: SortOption }[] = [
  { label: 'Title (A-Z)', value: SortOption.ALPHABETICAL },
  { label: 'Newest First', value: SortOption.NEWEST },
];

export const sortProcs = (
  procs: ProcSearchResponse[],
  sortOption: SortOption,
): ProcSearchResponse[] => {
  return [...procs].sort((a: ProcSearchResponse, b: ProcSearchResponse) => {
    switch (sortOption) {
      case SortOption.ALPHABETICAL:
        return a.title.localeCompare(b.title);
      case SortOption.NEWEST:
        return (
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
      default:
        return 0;
    }
  });
};

export const useSortedProcs = (
  procsData: PaginatedProcsResponse | undefined,
  selectedSortOption: SortOption,
): ProcSearchResponse[] => {
  return useMemo(() => {
    if (!procsData) return [];
    const allProcs = procsData.pages.flatMap((page) => page.data.data);
    const validProcs = allProcs.filter(
      (item: ProcSearchResponse) => !!item?.id && !!item?.title,
    );
    return sortProcs(validProcs, selectedSortOption);
  }, [procsData, selectedSortOption]);
};
export interface PaginatedProcsResponse {
  pages: Array<{
    data: {
      data: ProcSearchResponse[];
    };
  }>;
}
